import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const UseNavBara = () => {
  const [t, i18n] = useTranslation("global");

  const [bra, setBra] = useState(false);
  const [uk, setUk] = useState(false);
  const [esp, setEsp] = useState(false);
  const [modalFlag, setModalFlag] = useState(false);

  const spanishLanguage = () => {
    i18n.changeLanguage("es");
    setBra(false);
    setUk(false);
    setEsp(true);
  };
  const portugueseLanguage = () => {
    i18n.changeLanguage("por");
    setBra(true);
    setUk(false);
    setEsp(false);
  };
  const englishLanguage = () => {
    i18n.changeLanguage("en");
    setBra(false);
    setUk(true);
    setEsp(false);
  };

  const language = navigator.language || navigator.userLanguage;
  useEffect(() => {
    const ln = language.slice(0, 2);
    if (ln === "en") {
      setBra(false);
      setUk(true);
      setEsp(false);
    }
    if (ln === "es") {
      setBra(false);
      setUk(false);
      setEsp(true);
    }
    if (ln === "pt") {
      setBra(true);
      setUk(false);
      setEsp(false);
    }
  }, [language]);

  return {
    spanishLanguage,
    portugueseLanguage,
    englishLanguage,
    uk,
    esp,
    bra,
    modalFlag,
    setModalFlag,
    t,
  };
};

export default UseNavBara;
